import { useState } from "react";

import Input from "../../ui/input/Input";
import Button from "../../ui/button/Button";
import Alert from "../../ui/alert/Alert";

import "./LoginForm.css";

export default function LoginForm({ onSubmit, isLoading, error }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const canSubmit =
    email.trim().length > 0 && password.trim().length > 0 && !isLoading;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!canSubmit) return;

    onSubmit({
      email: email.trim(),
      password,
    });
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      {error && <Alert type="error">{error}</Alert>}

      <Input
        id="email"
        label="E-mailadres"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="naam@topuntgent.be"
        autoComplete="email"
        disabled={isLoading}
      />

      <Input
        id="password"
        label="Wachtwoord"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Voer je wachtwoord in"
        autoComplete="current-password"
        disabled={isLoading}
      />

      <Button type="submit" disabled={!canSubmit}>
        {isLoading ? "Aanmelden..." : "Aanmelden"}
      </Button>
    </form>
  );
}
